import React from "react";
import { useTranslation } from "react-i18next";
import FormInput from "src/components/Common/Form/FormInput";
import { FORM_NAME, PATTERN_NUMBER, PATTERN_NUMERIC_ARRAY_6DOF } from "src/constant/common";

const MRN01Sigma = ({ register, errors }) => {
  const { t } = useTranslation("gnc-simulator-6dof");
  return (
    <div className="row">
      <h3 className="mcs-block-title">{t("new.MCS.mrn_01_sigma_title")}</h3>
      <div className="col-md-6">
        <FormInput
          register={register}
          classGroup="ms-2"
          label={t(`new.MCS.${FORM_NAME.MCS.MAXIMUM_ACCELERATION}`)}
          name={`MCS.${FORM_NAME.MCS.MAXIMUM_ACCELERATION}`}
          placeholder={t("new.field_placeholder", { field: t(`new.MCS.${FORM_NAME.MCS.MAXIMUM_ACCELERATION}`) })}
          classInput="width-by-percent-80"
          errors={errors?.MCS?.[FORM_NAME.MCS.MAXIMUM_ACCELERATION]?.message}
          requiredMessage={t("new.field_required", { field: t(`new.MCS.${FORM_NAME.MCS.MAXIMUM_ACCELERATION}`) })}
          required
          pattern={{
            value: PATTERN_NUMBER,
            message: t("new.number_validate", { field: t(`new.MCS.${FORM_NAME.MCS.MAXIMUM_ACCELERATION}`) }),
          }}
          maxLength={255}
          maxLengthMessage={t("new.field_maxlength", { field: t(`new.MCS.${FORM_NAME.MCS.MAXIMUM_ACCELERATION}`) })}
        />
        <FormInput
          register={register}
          classGroup="ms-2"
          label={t(`new.MCS.${FORM_NAME.MCS.VELOCITY_RANDOM_WALK}`)}
          name={`MCS.${FORM_NAME.MCS.VELOCITY_RANDOM_WALK}`}
          placeholder={t("new.field_placeholder", { field: t(`new.MCS.${FORM_NAME.MCS.VELOCITY_RANDOM_WALK}`) })}
          classInput="width-by-percent-80"
          errors={errors?.MCS?.[FORM_NAME.MCS.VELOCITY_RANDOM_WALK]?.message}
          requiredMessage={t("new.field_required", { field: t(`new.MCS.${FORM_NAME.MCS.VELOCITY_RANDOM_WALK}`) })}
          required
          pattern={{
            value: PATTERN_NUMBER,
            message: t("new.number_validate", { field: t(`new.MCS.${FORM_NAME.MCS.VELOCITY_RANDOM_WALK}`) }),
          }}
          maxLength={255}
          maxLengthMessage={t("new.field_maxlength", { field: t(`new.MCS.${FORM_NAME.MCS.VELOCITY_RANDOM_WALK}`) })}
        />
        <FormInput
          register={register}
          classGroup="ms-2"
          label={t(`new.MCS.${FORM_NAME.MCS.TEMPERATURE_BIAS_OF_ACCELEROMETER}`)}
          name={`MCS.${FORM_NAME.MCS.TEMPERATURE_BIAS_OF_ACCELEROMETER}`}
          placeholder={t("new.field_placeholder", { field: t(`new.MCS.${FORM_NAME.MCS.TEMPERATURE_BIAS_OF_ACCELEROMETER}`) })}
          classInput="width-by-percent-80"
          errors={errors?.MCS?.[FORM_NAME.MCS.TEMPERATURE_BIAS_OF_ACCELEROMETER]?.message}
          requiredMessage={t("new.field_required", { field: t(`new.MCS.${FORM_NAME.MCS.TEMPERATURE_BIAS_OF_ACCELEROMETER}`) })}
          required
          pattern={{
            value: PATTERN_NUMBER,
            message: t("new.number_validate", { field: t(`new.MCS.${FORM_NAME.MCS.TEMPERATURE_BIAS_OF_ACCELEROMETER}`) }),
          }}
          maxLength={255}
          maxLengthMessage={t("new.field_maxlength", { field: t(`new.MCS.${FORM_NAME.MCS.TEMPERATURE_BIAS_OF_ACCELEROMETER}`) })}
        />
        <FormInput
          register={register}
          classGroup="ms-2"
          label={t(`new.MCS.${FORM_NAME.MCS.GYROSCOPE_LSB_RESOLUTION}`)}
          name={`MCS.${FORM_NAME.MCS.GYROSCOPE_LSB_RESOLUTION}`}
          placeholder={t("new.field_placeholder", { field: t(`new.MCS.${FORM_NAME.MCS.GYROSCOPE_LSB_RESOLUTION}`) })}
          classInput="width-by-percent-80"
          errors={errors?.MCS?.[FORM_NAME.MCS.GYROSCOPE_LSB_RESOLUTION]?.message}
          requiredMessage={t("new.field_required", { field: t(`new.MCS.${FORM_NAME.MCS.GYROSCOPE_LSB_RESOLUTION}`) })}
          required
          pattern={{
            value: PATTERN_NUMBER,
            message: t("new.number_validate", { field: t(`new.MCS.${FORM_NAME.MCS.GYROSCOPE_LSB_RESOLUTION}`) }),
          }}
          maxLength={255}
          maxLengthMessage={t("new.field_maxlength", { field: t(`new.MCS.${FORM_NAME.MCS.GYROSCOPE_LSB_RESOLUTION}`) })}
        />
        <FormInput
          register={register}
          classGroup="ms-2"
          label={t(`new.MCS.${FORM_NAME.MCS.GYRO_BIAS}`)}
          name={`MCS.${FORM_NAME.MCS.GYRO_BIAS}`}
          placeholder={t("new.field_placeholder", { field: t(`new.MCS.${FORM_NAME.MCS.GYRO_BIAS}`) })}
          classInput="width-by-percent-80"
          errors={errors?.MCS?.[FORM_NAME.MCS.GYRO_BIAS]?.message}
          requiredMessage={t("new.field_required", { field: t(`new.MCS.${FORM_NAME.MCS.GYRO_BIAS}`) })}
          required
          pattern={{
            value: PATTERN_NUMBER,
            message: t("new.number_validate", { field: t(`new.MCS.${FORM_NAME.MCS.GYRO_BIAS}`) }),
          }}
          maxLength={255}
          maxLengthMessage={t("new.field_maxlength", { field: t(`new.MCS.${FORM_NAME.MCS.GYRO_BIAS}`) })}
        />
        <FormInput
          register={register}
          classGroup="ms-2"
          type="number"
          label={t(`new.MCS.${FORM_NAME.MCS.SKEW_OF_SENSOR_AXES}`)}
          name={`MCS.${FORM_NAME.MCS.SKEW_OF_SENSOR_AXES}`}
          placeholder={t("new.field_placeholder", { field: t(`new.MCS.${FORM_NAME.MCS.SKEW_OF_SENSOR_AXES}`) })}
          classInput="width-by-percent-80"
          errors={errors?.MCS?.[FORM_NAME.MCS.SKEW_OF_SENSOR_AXES]?.message}
          requiredMessage={t("new.field_required", { field: t(`new.MCS.${FORM_NAME.MCS.SKEW_OF_SENSOR_AXES}`) })}
          required
          maxLength={255}
          maxLengthMessage={t("new.field_maxlength", { field: t(`new.MCS.${FORM_NAME.MCS.SKEW_OF_SENSOR_AXES}`) })}
          pattern={{
            value: PATTERN_NUMERIC_ARRAY_6DOF,
            message: t("new.wrong_format", { field: t(`new.MCS.${FORM_NAME.MCS.SKEW_OF_SENSOR_AXES}`) }),
          }}
        />
      </div>
      <div className="col-md-6">
        <FormInput
          register={register}
          classGroup="ms-2"
          label={t(`new.MCS.${FORM_NAME.MCS.ACCELEROMETER_LSB_RESOLUTION}`)}
          name={`MCS.${FORM_NAME.MCS.ACCELEROMETER_LSB_RESOLUTION}`}
          placeholder={t("new.field_placeholder", { field: t(`new.MCS.${FORM_NAME.MCS.ACCELEROMETER_LSB_RESOLUTION}`) })}
          classInput="width-by-percent-80"
          errors={errors?.MCS?.[FORM_NAME.MCS.ACCELEROMETER_LSB_RESOLUTION]?.message}
          requiredMessage={t("new.field_required", { field: t(`new.MCS.${FORM_NAME.MCS.ACCELEROMETER_LSB_RESOLUTION}`) })}
          required
          pattern={{
            value: PATTERN_NUMBER,
            message: t("new.number_validate", { field: t(`new.MCS.${FORM_NAME.MCS.ACCELEROMETER_LSB_RESOLUTION}`) }),
          }}
          maxLength={255}
          maxLengthMessage={t("new.field_maxlength", { field: t(`new.MCS.${FORM_NAME.MCS.ACCELEROMETER_LSB_RESOLUTION}`) })}
        />
        <FormInput
          register={register}
          classGroup="ms-2"
          label={t(`new.MCS.${FORM_NAME.MCS.ACCELEROMETER_BIAS}`)}
          name={`MCS.${FORM_NAME.MCS.ACCELEROMETER_BIAS}`}
          placeholder={t("new.field_placeholder", { field: t(`new.MCS.${FORM_NAME.MCS.ACCELEROMETER_BIAS}`) })}
          classInput="width-by-percent-80"
          errors={errors?.MCS?.[FORM_NAME.MCS.ACCELEROMETER_BIAS]?.message}
          requiredMessage={t("new.field_required", { field: t(`new.MCS.${FORM_NAME.MCS.ACCELEROMETER_BIAS}`) })}
          required
          pattern={{
            value: PATTERN_NUMBER,
            message: t("new.number_validate", { field: t(`new.MCS.${FORM_NAME.MCS.ACCELEROMETER_BIAS}`) }),
          }}
          maxLength={255}
          maxLengthMessage={t("new.field_maxlength", { field: t(`new.MCS.${FORM_NAME.MCS.ACCELEROMETER_BIAS}`) })}
        />
        <FormInput
          register={register}
          classGroup="ms-2"
          label={t(`new.MCS.${FORM_NAME.MCS.MAX_GYRO}`)}
          name={`MCS.${FORM_NAME.MCS.MAX_GYRO}`}
          placeholder={t("new.field_placeholder", { field: t(`new.MCS.${FORM_NAME.MCS.MAX_GYRO}`) })}
          classInput="width-by-percent-80"
          errors={errors?.MCS?.[FORM_NAME.MCS.MAX_GYRO]?.message}
          requiredMessage={t("new.field_required", { field: t(`new.MCS.${FORM_NAME.MCS.MAX_GYRO}`) })}
          required
          pattern={{
            value: PATTERN_NUMBER,
            message: t("new.number_validate", { field: t(`new.MCS.${FORM_NAME.MCS.MAX_GYRO}`) }),
          }}
          maxLength={255}
          maxLengthMessage={t("new.field_maxlength", { field: t(`new.MCS.${FORM_NAME.MCS.MAX_GYRO}`) })}
        />
        <FormInput
          register={register}
          classGroup="ms-2"
          label={t(`new.MCS.${FORM_NAME.MCS.ANGLE_RANDOM_WALK}`)}
          name={`MCS.${FORM_NAME.MCS.ANGLE_RANDOM_WALK}`}
          placeholder={t("new.field_placeholder", { field: t(`new.MCS.${FORM_NAME.MCS.ANGLE_RANDOM_WALK}`) })}
          classInput="width-by-percent-80"
          errors={errors?.MCS?.[FORM_NAME.MCS.ANGLE_RANDOM_WALK]?.message}
          requiredMessage={t("new.field_required", { field: t(`new.MCS.${FORM_NAME.MCS.ANGLE_RANDOM_WALK}`) })}
          required
          pattern={{
            value: PATTERN_NUMBER,
            message: t("new.number_validate", { field: t(`new.MCS.${FORM_NAME.MCS.ANGLE_RANDOM_WALK}`) }),
          }}
          maxLength={255}
          maxLengthMessage={t("new.field_maxlength", { field: t(`new.MCS.${FORM_NAME.MCS.ANGLE_RANDOM_WALK}`) })}
        />
        <FormInput
          register={register}
          classGroup="ms-2"
          label={t(`new.MCS.${FORM_NAME.MCS.TEMPERATURE_BIAS_OF_GYRO}`)}
          name={`MCS.${FORM_NAME.MCS.TEMPERATURE_BIAS_OF_GYRO}`}
          placeholder={t("new.field_placeholder", { field: t(`new.MCS.${FORM_NAME.MCS.TEMPERATURE_BIAS_OF_GYRO}`) })}
          classInput="width-by-percent-80"
          errors={errors?.MCS?.[FORM_NAME.MCS.TEMPERATURE_BIAS_OF_GYRO]?.message}
          requiredMessage={t("new.field_required", { field: t(`new.MCS.${FORM_NAME.MCS.TEMPERATURE_BIAS_OF_GYRO}`) })}
          required
          pattern={{
            value: PATTERN_NUMBER,
            message: t("new.number_validate", { field: t(`new.MCS.${FORM_NAME.MCS.TEMPERATURE_BIAS_OF_GYRO}`) }),
          }}
          maxLength={255}
          maxLengthMessage={t("new.field_maxlength", { field: t(`new.MCS.${FORM_NAME.MCS.TEMPERATURE_BIAS_OF_GYRO}`) })}
        />
      </div>
    </div>
  );
};

export default MRN01Sigma;
